<template>
    <OrderInfoBox v-if="marker.order" :order="marker.order" :show="false" />
</template>
<script>


    import OrderInfoBox from "./OrderInfoBox";
    export default {
        components: {OrderInfoBox},
        props: {
            google: {
                type: Object,
                required: true
            },
            map: {
                type: Object,
                required: true
            },
            marker: {
                type: Object,
                required: true
            }
        },
        watch: {
            marker: {
                deep: true,
                handler(val) {
                    this.changeIcon(val)
                    this.object.setPosition(new this.google.maps.LatLng({
                        lat: val.position.lat,
                        lng: val.position.lng
                    }));
                }
            }
        },
        methods: {
            // A marker.icon is either a url string or a google.maps.Icon-shaped object.
            // Its anchor/scaledSize may be given as plain {x,y} / {width,height} literals
            // so callers building markers never need the google namespace.
            buildIcon(marker) {
                if (!marker.icon) {
                    if (marker.label && marker.iconColor) {
                        return {url: this.$svgMarker(marker.label, marker.iconColor)}
                    }
                    return null;
                }
                if (typeof marker.icon === "string") return {url: marker.icon};

                const icon = Object.assign({}, marker.icon);
                if (icon.anchor && !(icon.anchor instanceof this.google.maps.Point)) {
                    icon.anchor = new this.google.maps.Point(icon.anchor.x, icon.anchor.y);
                }
                if (icon.scaledSize && !(icon.scaledSize instanceof this.google.maps.Size)) {
                    icon.scaledSize = new this.google.maps.Size(icon.scaledSize.width, icon.scaledSize.height);
                }
                return icon;
            },
            changeIcon(marker) {
                this.object.setIcon(this.buildIcon(marker));
            }
        },
        data() {
            return {
                object: null,
            }
        },
        beforeDestroy() {
            this.object.setMap(null);
        },
        mounted() {
            let obj = {
                position: new this.google.maps.LatLng(this.marker.position),
                marker: this.marker,
                map: this.map,
                defaultMarker: 0.5,
            };
            if (this.marker.draggable) Object.assign(obj, {draggable: true})
            if (this.marker.optimized) Object.assign(obj, {optimized: true})
            if (this.marker.zIndex) Object.assign(obj, {zIndex: this.marker.zIndex})
            const icon = this.buildIcon(this.marker);
            if (icon) Object.assign(obj, {icon})
            else if (this.marker.label) Object.assign(obj, {label: this.marker.label.toString()})
            if (this.marker.title) Object.assign(obj, {title: this.marker.title.toString()})
            if (this.marker.animation) Object.assign(obj, {animation: this.google.maps.Animation[this.marker.animation]})

            this.object = new this.google.maps.Marker(obj)
            if (this.marker.change) this.google.maps.event.addListener(this.object, 'dragend', this.marker.change);
            if (this.marker.infoWindow || this.marker.orderInfoWindow) {

                this.object.addListener("click", (e) => {
                    const infoWindow = new this.google.maps.InfoWindow({
                        // content: this.marker.infoWindow
                        content: this.marker.orderInfoWindow ? this.$children[0].$el.innerHTML : this.marker.infoWindow
                    });
                    infoWindow.setPosition(e.latLng);
                    infoWindow.open(this.map)
                })
            }
            if (this.marker.center) this.map.setCenter(this.marker.position)
        }
    }
</script>
